import React from "react";

import RatingStarsRow from "./RatingStarsRow";

const TONE_LABELS = {
   1: "Foarte slab",
   2: "Slab",
   3: "Mediu",
   4: "Bun",
   5: "Excelent",
};

export default function StudentRatingPicker({
   value = 0,
   previewValue = 0,
   max = 5,
   disabled = false,
   onChange,
   onPreviewChange,
}) {
   const rating = Number(value);
   const safe = Number.isFinite(rating)
      ? Math.max(0, Math.min(max, rating))
      : 0;
   const preview = Number(previewValue);
   const activeCount =
      Number.isFinite(preview) && preview > 0 ? preview : safe;

   return (
      <div className="studentMandatoryRatingsPopup__ratingBlock">
         <RatingStarsRow
            value={value}
            previewValue={previewValue}
            max={max}
            interactive
            disabled={disabled}
            onChange={onChange}
            onPreviewChange={onPreviewChange}
         />

         <p className="studentMandatoryRatingsPopup__ratingHint">
            {activeCount > 0
               ? TONE_LABELS[activeCount] || `${activeCount} stele`
               : "Apasă pe stele pentru a evalua"}
         </p>
      </div>
   );
}
